import { ReportType } from './ReportType';

export const PDFReportActions: Partial<Record<ReportType, string>> = {
  [ReportType.Feeding]: 'feeding',
  [ReportType.Drinking]: 'drinking',
  [ReportType.Movement]: 'activity',
};
